import React, {FC, InputHTMLAttributes} from 'react';
import classes from './HLCheckbox.module.scss';

interface HLCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
    id: string;
}

export const HLCheckbox: FC<HLCheckboxProps> = (
    {
        id,
        children,
        ...props
    }) => {
    return (
        <div className={`${classes.checkboxContainer}`}>
            <input
                id={id}
                type="checkbox"
                className={classes.checkboxInput}
                {...props}
            />
            {children && (
                <label className={classes.inputLabel} htmlFor={id}>
                    {children}
                </label>
            )}
        </div>
    );
};